const singleDateStates = [
  'EMPTY',
  'ENABLE',
  'DISABLE',
  'SELECTED'
];

const SINGLE_DATE_STATE = singleDateStates.reduce((acc, curr) => { acc[curr] = curr; return { ...acc }; }, {});

const singleSlotStates = [
  'EMPTY',
  'SELECTED',
  'DISABLED'
];

const SINGLE_SLOT_STATE = singleSlotStates.reduce((acc, curr) => { acc[curr] = curr; return { ...acc }; }, {});

const CALENDAR_CONSTANT = {
  DATE_TIME_FORMAT: 'YYYY-MM-DD HH:mm',
  DATE_ONLY_FORMAT: 'YYYY-MM-DD',
  TAG_DATE_SELECTED: 'date_selected',
  TAG_DATE_UNSELECTED: 'date_unselected',
  TAG_TIME_SLOT: 'time_slot',
  COMPARE_DAY: 'day'
};

export {
  SINGLE_DATE_STATE,
  SINGLE_SLOT_STATE,
  CALENDAR_CONSTANT
};
